// components/Hotel.js - VERSIÓN CON LÓGICA MEJORADA DE CRÉDITO
import React, { useState, useEffect, useRef } from "react";
import "../styles/Hotel.css";

// Componente para mostrar detalles completos
const DetallesCompletos = ({ data, onClose }) => {
  if (!data) return null;

  const formatValue = (value) => {
    if (value === null || value === undefined) return "—";
    if (typeof value === "boolean") return value ? "Sí" : "No";
    if (typeof value === "object") return JSON.stringify(value, null, 2);
    return String(value);
  };

  const encontrarFechaSalida = () => {
    const posiblesCampos = [
      data?.checkOutDate,
      data?.departureDate,
      data?.guestDetails?.checkOutDate,
      data?.headerInfo?.checkOutDate,
      data?.fechas?.salida,
      data?.reservation?.checkOut,
      data?.fechaSalida,
      data?.salida,
      ...Object.keys(data).filter(key => 
        key.toLowerCase().includes('date') || 
        key.toLowerCase().includes('salida') ||
        key.toLowerCase().includes('checkout') ||
        key.toLowerCase().includes('departure')
      ).map(key => data[key])
    ];
    
    const fechaEncontrada = posiblesCampos.find(campo => campo && String(campo).trim() !== "");
    return fechaEncontrada ? String(fechaEncontrada) : "No disponible";
  };

  const renderObject = (obj, nivel = 0) => {
    if (!obj || typeof obj !== 'object') return null;
    
    return Object.entries(obj).map(([key, value]) => {
      const isObject = value && typeof value === 'object' && !Array.isArray(value);
      const isArray = Array.isArray(value);
      
      return (
        <div key={key} className="detalle-item" style={{ marginLeft: `${nivel * 20}px` }}>
          <div className="detalle-clave">
            <strong>{key}:</strong>
            {isObject && <i className="fas fa-folder-open"></i>}
            {isArray && <i className="fas fa-list"></i>}
          </div>
          <div className="detalle-valor">
            {isObject ? (
              <div className="detalle-objeto">
                {renderObject(value, nivel + 1)}
              </div>
            ) : isArray ? (
              <div className="detalle-array">
                {value.map((item, idx) => (
                  <div key={idx} className="detalle-array-item">
                    [{idx}]: {typeof item === 'object' ? renderObject(item, nivel + 1) : formatValue(item)}
                  </div>
                ))}
              </div>
            ) : (
              <span className={`detalle-valor-texto ${key.toLowerCase().includes('date') ? 'fecha-destacada' : ''}`}>
                {formatValue(value)}
              </span>
            )}
          </div>
        </div>
      );
    });
  };

  return (
    <div className="detalles-modal-overlay">
      <div className="detalles-modal-content">
        <div className="detalles-modal-header">
          <h3>
            <i className="fas fa-info-circle"></i> 
            Datos Completos del PMS
          </h3>
          <button onClick={onClose} className="close-btn">×</button>
        </div>

        <div className="detalles-modal-body">
          <div className="fecha-salida-card">
            <div className="fecha-salida-icono">
              <i className="fas fa-calendar-check"></i>
            </div>
            <div className="fecha-salida-info">
              <span className="fecha-salida-label">Fecha de Salida</span>
              <span className="fecha-salida-valor">{encontrarFechaSalida()}</span>
            </div>
          </div>

          <div className="referencias-card">
            <h4><i className="fas fa-tags"></i> Referencias</h4>
            <div className="referencias-grid">
              <div className="referencia-item">
                <span className="referencia-label">Reference 1:</span>
                <span className="referencia-valor">
                  {data?.guestDetails?.reference1 || data?.reference1 || "—"}
                </span>
              </div>
              <div className="referencia-item">
                <span className="referencia-label">Reference 2:</span>
                <span className="referencia-valor">
                  {data?.guestDetails?.reference2 || data?.reference2 || "—"}
                </span>
              </div>
            </div>
          </div>

          <div className="destacados-grid">
            {data?.vip && (
              <div className="destacado-item">
                <i className="fas fa-crown"></i>
                <span>VIP: {data.vip}</span>
              </div>
            )}
            {data?.guestDetails?.paymentMethodDefault && (
              <div className="destacado-item">
                <i className="fas fa-credit-card"></i>
                <span>Pago: {data.guestDetails.paymentMethodDefault}</span>
              </div>
            )}
          </div>

          <div className="datos-completos">
            <h4><i className="fas fa-database"></i> Todos los Campos Recibidos</h4>
            <div className="datos-arbol">
              {renderObject(data)}
            </div>
          </div>

          <details className="raw-json">
            <summary>
              <i className="fas fa-code"></i> Ver JSON completo
            </summary>
            <pre>{JSON.stringify(data, null, 2)}</pre>
          </details>
        </div>
      </div>
    </div>
  );
};

// COMPONENTE PRINCIPAL
const Hotel = ({ property, onClose, mostrarMensaje, currentUser }) => {
  const [roomNumber, setRoomNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [consultaResult, setConsultaResult] = useState(null);
  const [error, setError] = useState(null);
  const [mostrarDetalles, setMostrarDetalles] = useState(false);
  
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
  }, []);

  // ✅ LÓGICA MEJORADA PARA DETERMINAR SI PUEDE CARGAR
  const puedeCargar = () => {
    if (!consultaResult) return false;
    
    // Caso 1: NoPost explícito
    if (consultaResult.noPost === true) return false;
    
    // Caso 2: Límite de crédito es 0 o null/undefined
    const creditLimit = consultaResult.creditLimit;
    if (creditLimit === 0 || creditLimit === null || creditLimit === undefined) return false;
    
    // Caso 3: Tiene crédito positivo Y no tiene NoPost
    return creditLimit > 0;
  };

  // ✅ MENSAJE DESCRIPTIVO DEL ESTADO
  const getEstadoMensaje = () => {
    if (!consultaResult) return "";
    
    if (consultaResult.noPost === true) {
      return "BLOQUEADO: NoPost activo";
    }
    
    const creditLimit = consultaResult.creditLimit;
    if (creditLimit === 0 || creditLimit === null || creditLimit === undefined) {
      return "SIN CRÉDITO: Límite $0";
    }
    
    if (creditLimit > 0) {
      return "CRÉDITO DISPONIBLE";
    }
    
    return "ESTADO DESCONOCIDO";
  };

  const handleConsultar = async () => {
    const room = roomNumber.trim();

    if (!room) {
      mostrarMensaje("❌ Ingresa un número de habitación");
      return;
    }

    setLoading(true);
    setError(null);
    setConsultaResult(null);

    try {
      const url = `https://www.bts.ei-solutions.co/shopeis/app_menu/consultar-habitacion.php?property=${encodeURIComponent(property)}&roomNumber=${encodeURIComponent(room)}`;

      console.log("🔍 Consultando:", url);

      const response = await fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" },
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();
      console.log("✅ Datos completos del PMS:", data);

      if (!data.success) {
        mostrarMensaje(`⚠️ ${data.message || "Error"}`);
        setError(data.message);
        return;
      }

      setConsultaResult(data);
      
      // Mensaje descriptivo según el estado
      if (data.noPost === true) {
        mostrarMensaje("⚠️ Esta habitación tiene NoPost activo - NO puede cargar");
      } else if (data.creditLimit === 0) {
        mostrarMensaje("⚠️ Esta habitación tiene límite $0 - NO puede cargar");
      } else {
        mostrarMensaje(`✅ Habitación ${room} consultada - Límite: $${data.creditLimit}`);
      }

    } catch (err) {
      console.error("❌ Error:", err);
      mostrarMensaje(`❌ ${err.message}`);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAbrirMesa = () => {
    if (!puedeCargar()) {
      mostrarMensaje(`❌ No se puede abrir mesa: ${getEstadoMensaje()}`);
      return;
    }

    mostrarMensaje(`✅ Abriendo mesa para ${consultaResult.guestName || roomNumber}`);
    setTimeout(onClose, 1500);
  };

  const handleCerrarCuenta = async () => {
    if (!puedeCargar()) {
      mostrarMensaje(`❌ No se puede cargar: ${getEstadoMensaje()}`);
      return;
    }

    try {
      mostrarMensaje("🔄 Procesando cargo...");

      const cargoData = {
        property: consultaResult.property || property,
        roomNumber: consultaResult.roomNumber || roomNumber,
        reservationId: consultaResult.reservationId,
        profileId: consultaResult.profileId,
        guestName: consultaResult.guestName,
        subtotal1: 215.52,
        subtotal2: 215.52,
        tax1: 68.96,
        totalAmount: 500.00,
        paymentMethod: "11",
        mesero: currentUser?.nombre || "SISTEMA",
        referencia: `POS-${Date.now()}`
      };

      const response = await fetch(
        "https://www.bts.ei-solutions.co/shopeis/app_menu/cargo-habitacion.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(cargoData),
        }
      );

      const data = await response.json();
      if (!data.success) throw new Error(data.message);

      mostrarMensaje("✅ Cargo exitoso");
      setTimeout(onClose, 2000);

    } catch (err) {
      mostrarMensaje(`❌ ${err.message}`);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount || 0);
  };

  const puede = puedeCargar();
  const estadoMsg = getEstadoMensaje();

  if (mostrarDetalles) {
    return (
      <DetallesCompletos 
        data={consultaResult} 
        onClose={() => setMostrarDetalles(false)} 
      />
    );
  }

  return (
    <div className="hotel-modal-overlay">
      <div className="hotel-modal-content">
        <div className="hotel-modal-header">
          <h3><i className="fas fa-hotel"></i> Sistema Hotelero</h3>
          <button onClick={onClose} className="close-btn">×</button>
        </div>

        <div className="hotel-modal-body">
          <div className="input-section">
            <label><i className="fas fa-door-open"></i> Habitación</label>
            <div className="input-group">
              <input
                ref={inputRef}
                type="text"
                value={roomNumber}
                onChange={(e) => setRoomNumber(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleConsultar()}
                placeholder="Ej: 820"
                className="room-input"
                disabled={loading}
              />
              <button
                onClick={handleConsultar}
                disabled={loading || !roomNumber.trim()}
                className="consultar-btn"
              >
                {loading ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-search"></i>}
                {loading ? " Consultando..." : " Consultar"}
              </button>
            </div>
          </div>

          {error && (
            <div className="error-message">
              <i className="fas fa-exclamation-triangle"></i> {error}
            </div>
          )}

          {consultaResult && (
            <div className="consulta-result">
              
              <div className="guest-highlight">
                <i className="fas fa-user-circle guest-avatar"></i>
                <div className="guest-info">
                  <span className="guest-label">Huésped</span>
                  <span className="guest-name-large">
                    {consultaResult.guestName || "Sin nombre"}
                  </span>
                </div>
                {consultaResult.vip && (
                  <span className="vip-badge">
                    <i className="fas fa-crown"></i> VIP {consultaResult.vip}
                  </span>
                )}
              </div>

              <div className="info-card">
                <div className="info-row">
                  <span className="info-label"><i className="fas fa-door-closed"></i> Habitación:</span>
                  <span className="info-value badge-room">{consultaResult.roomNumber || roomNumber}</span>
                </div>
                
                <div className="info-row">
                  <span className="info-label"><i className="fas fa-id-card"></i> Reservation ID:</span>
                  <span className="info-value badge-id">{consultaResult.reservationId || "N/A"}</span>
                </div>
                
                <div className="info-row">
                  <span className="info-label"><i className="fas fa-id-badge"></i> Profile ID:</span>
                  <span className="info-value badge-id">{consultaResult.profileId || "N/A"}</span>
                </div>

                {consultaResult.guestDetails?.title && (
                  <div className="info-row">
                    <span className="info-label"><i className="fas fa-user-tag"></i> Título:</span>
                    <span className="info-value">{consultaResult.guestDetails.title}</span>
                  </div>
                )}
              </div>

              <div className="credit-card">
                <h5><i className="fas fa-credit-card"></i> Crédito</h5>
                
                <div className="credit-row">
                  <span className="credit-label">Límite:</span>
                  <span className="credit-value">{formatCurrency(consultaResult.creditLimit)}</span>
                </div>

                <div className="credit-row">
                  <span className="credit-label">Disponible:</span>
                  <span className="credit-value credit-available">
                    {formatCurrency(consultaResult.creditLimit)}
                  </span>
                </div>

                {/* ✅ ESTADO MEJORADO CON DESCRIPCIÓN CLARA */}
                <div className={`status-detallado ${puede ? 'status-ok' : 'status-error'}`}>
                  <div className="status-icono">
                    <i className={`fas fa-${puede ? 'check-circle' : 'times-circle'}`}></i>
                  </div>
                  <div className="status-info">
                    <div className="status-titulo">
                      {puede ? '✅ PUEDE CARGAR' : '❌ NO PUEDE CARGAR'}
                    </div>
                    <div className="status-descripcion">
                      {estadoMsg}
                      {!puede && consultaResult.creditLimit === 0 && (
                        <span className="status-razon"> (Límite $0 - sin crédito)</span>
                      )}
                      {!puede && consultaResult.noPost === true && (
                        <span className="status-razon"> (NoPost activo - bloqueado)</span>
                      )}
                    </div>
                  </div>
                </div>

                {!puede && (
                  <div className={`warning-message ${consultaResult.noPost ? 'warning-no-post' : 'warning-sin-credito'}`}>
                    <i className="fas fa-exclamation-triangle"></i>
                    <div>
                      <strong>¡ATENCIÓN!</strong><br />
                      {consultaResult.noPost 
                        ? "Este huésped tiene prohibido cargos a habitación (NoPost activo)" 
                        : "Este huésped no tiene límite de crédito disponible ($0)"}
                    </div>
                  </div>
                )}
              </div>

              {consultaResult.guestDetails && (
                <div className="details-card">
                  <h5><i className="fas fa-info-circle"></i> Detalles</h5>
                  
                  {consultaResult.guestDetails.paymentMethodDefault && (
                    <div className="detail-row">
                      <span className="detail-label">Pago por defecto:</span>
                      <span className="detail-value">{consultaResult.guestDetails.paymentMethodDefault}</span>
                    </div>
                  )}
                  
                  {consultaResult.guestDetails.reference1 && (
                    <div className="detail-row">
                      <span className="detail-label">Referencia 1:</span>
                      <span className="detail-value">{consultaResult.guestDetails.reference1}</span>
                    </div>
                  )}
                  
                  {consultaResult.guestDetails.reference2 && (
                    <div className="detail-row">
                      <span className="detail-label">Referencia 2:</span>
                      <span className="detail-value">{consultaResult.guestDetails.reference2}</span>
                    </div>
                  )}
                </div>
              )}

              <div className="ver-todos-container">
                <button 
                  onClick={() => setMostrarDetalles(true)}
                  className="ver-todos-btn"
                >
                  <i className="fas fa-eye"></i> Ver todos los datos del PMS
                  <small>(fecha salida, referencias, campos nuevos...)</small>
                </button>
              </div>

              <div className="action-buttons">
                {puede && (
                  <>
                    <button onClick={handleAbrirMesa} className="action-btn abrir-mesa-btn">
                      <i className="fas fa-utensils"></i> Abrir Mesa
                    </button>
                    <button onClick={handleCerrarCuenta} className="action-btn cerrar-cuenta-btn">
                      <i className="fas fa-file-invoice-dollar"></i> Cargar a Habitación
                    </button>
                  </>
                )}
                
                <button
                  onClick={() => {
                    setRoomNumber("");
                    setConsultaResult(null);
                    setError(null);
                    inputRef.current?.focus();
                  }}
                  className="action-btn nueva-consulta-btn"
                >
                  <i className="fas fa-redo"></i> Nueva Consulta
                </button>
              </div>

              <div className="system-info">
                <p><i className="fas fa-building"></i> Property: {consultaResult.property || property}</p>
                <p><i className="fas fa-clock"></i> {new Date().toLocaleString()}</p>
              </div>
            </div>
          )}

          {!consultaResult && !loading && !error && (
            <div className="empty-state">
              <i className="fas fa-hotel empty-icon"></i>
              <p>Ingresa un número de habitación</p>
              <small>Ej: 101, 205, 820</small>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Hotel;